import $ from 'jquery'

/** Skrije pretekle dneve in že končane razpone ur za danes (časovni pas WordPressa). */
function setup(root) {
	const days = Array.from(root.querySelectorAll('input[name="prosti_dan"]'))
	const allDays = days.find((input) => input.value === 'all')
	const hours = Array.from(root.querySelectorAll('input[name="prosta_ura"]'))
	const allHours = hours.find((input) => input.value === 'all')
	if (!allDays || !allHours) return
	const lastHour = Math.max(...hours.filter((input) => input !== allHours).map((input) => Number(input.value.split('-')[1])))

	// WordPress podpira tako imena časovnih pasov kot fiksne odmike, npr. +02:00.
	const timeZone = root.dataset.timezone || 'UTC'
	const offset = /^([+-])(\d{2}):(\d{2})$/.exec(timeZone)
	const offsetMs = offset ? (offset[1] === '-' ? -1 : 1) * (Number(offset[2]) * 60 + Number(offset[3])) * 60000 : 0
	const formatter = new Intl.DateTimeFormat('en-GB', {
		timeZone: offset ? 'UTC' : timeZone,
		year: 'numeric', month: '2-digit', day: '2-digit',
		hour: '2-digit', minute: '2-digit', hour12: false,
	})

	const update = () => {
		// Uro izračunamo v brskalniku, da ostane pravilna tudi pri predpomnjeni strani.
		const parts = {}
		formatter.formatToParts(new Date(Date.now() + offsetMs)).forEach(({ type, value }) => { parts[type] = value })
		const today = `${parts.year}-${parts.month}-${parts.day}`
		const minutes = (Number(parts.hour) % 24) * 60 + Number(parts.minute)
		let reset = null

		days.forEach((input) => {
			if (input === allDays) return
			const expired = input.value < today || (input.value === today && minutes >= lastHour * 60)
			input.disabled = expired
			input.closest('label').hidden = expired
			if (expired && input.checked) {
				allDays.checked = true
				allHours.checked = true
				reset = allDays
			}
		})
		const day = root.querySelector('input[name="prosti_dan"]:checked')

		hours.forEach((input) => {
			if (input === allHours) return
			const endHour = Number(input.value.split('-')[1])
			const expired = !!day && day.value === today && minutes >= endHour * 60
			input.disabled = expired
			input.closest('label').hidden = expired
			if (expired && input.checked) {
				allHours.checked = true
				reset = allHours
			}
		})
		return reset
	}

	// Neposredni handlerji tečejo pred nalaganjem restavracij, tudi pri obnovi piškotka.
	// Ob spremembi dneva se morebitna pretekla ura ponastavi v isti zahtevi.
	$(root).find('input[name="prosti_dan"], input[name="prosta_ura"]').on('change', () => { update() })

	let timer
	const refresh = () => {
		const reset = update()
		if (reset) $(reset).trigger('change')
		window.clearTimeout(timer)
		timer = window.setTimeout(refresh, 60000 - Date.now() % 60000)
	}
	refresh()
	document.addEventListener('visibilitychange', () => {
		if (!document.hidden) refresh()
	})
}

export default {
	init() {
		document.querySelectorAll('[data-prosti-termini]').forEach(setup)
	},
}
